module.exports = __webpack_public_path__ + "uy.svg?4caed1247a7d571f081e9cf2015038a9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/uy.svg
// module id = 1422
// module chunks = 0